// extracted by mini-css-extract-plugin
export default {"contact_sect_title":"ContactRow_contact_sect_title__bu2-V","contact_cards":"ContactRow_contact_cards__jW0Y1"};